import { createReducer } from "@reduxjs/toolkit";
import * as actions from "./actions";

interface AnalyticsFilterMeta {
  url: string;
  accessor: string;
  label: string;
}

const initialState = {
  filterList: [] as any[],
  // Page-level dropdown metadata declared by the backend
  // {SubFilterConfiguration} (PR 1). When present, the secondary filter
  // dialog renders these as lazy dropdowns and ignores `filterList` (which
  // is the legacy widget-sourced channel).
  analyticsFilters: [] as AnalyticsFilterMeta[],
  // When true, chart widgets must NOT push their row data into
  // `filterList` via `addWidgetToFilterList`; the page is sourcing its
  // dropdowns from dedicated `dropdown_query` blocks instead.
  disableWidgetSourcedFilters: false,
  focusFilter: {
    location: "",
    widget: "",
  },
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.addWidgetToFilterList, (state, action) => {
    if (state.disableWidgetSourcedFilters) {
      return;
    }
    const filterItemIndex = state.filterList.findIndex(
      (d) => action.payload.filterKey === d.filterKey
    );
    if (filterItemIndex !== -1) {
      state.filterList[filterItemIndex] = action.payload;
    } else {
      state.filterList.push(action.payload);
    }
  });
  builder.addCase(actions.clearFilterList, (state, action) => {
    state.filterList = [];
  });
  builder.addCase(actions.setAnalyticsFilters, (state, action) => {
    state.analyticsFilters = action.payload;
  });
  builder.addCase(actions.setDisableWidgetSourcedFilters, (state, action) => {
    state.disableWidgetSourcedFilters = action.payload;
  });
  builder.addCase(actions.focusSecondaryFilter, (state, action) => {
    state.focusFilter.widget = action.payload;
  });
  builder.addCase(actions.clearSecondaryFilterFocus, (state, action) => {
    state.focusFilter.widget = "";
  });
  builder.addCase(actions.focusLocationFilter, (state, action) => {
    state.focusFilter.location = action.payload;
  });
  builder.addCase(actions.clearLocationFilterFocus, (state, actions) => {
    state.focusFilter.location = "";
  });
});
